/**
 * Handles actions related to textbox type of field settings
 * 
 * We want to prevent script usage in the Advanced section labels
 * 
 * @package Ninja Forms builder
 * @subpackage Fields - Edit Field Drawer
 * @copyright (c) 2024 Saturday Drive
 * @since 3.8
 */
define( 'controllers/app/textboxSetting',[], function() {
	/**
	 * Build the forbidden-character warning.
	 *
	 * The error is written into the page as HTML, so the character the visitor
	 * typed is escaped before it goes in: one of the five forbidden characters
	 * is the quotation mark and another is the less-than sign. It is also made
	 * bold, because the whole point of the message is to show which character
	 * was rejected. A stale localized value from before the placeholder existed
	 * has none, so the character is put in front of it as it used to be.
	 *
	 * @param {string} phrase    The localized message, which may carry a %s.
	 * @param {string} character The rejected character.
	 * @return {string} The warning as an HTML string.
	 */
	function nfGetForbiddenCharacterMessage( phrase, character ) {
		var marked = '<strong>' + _.escape( character ) + '</strong>';

		phrase = phrase || '';
		return -1 !== phrase.indexOf( '%s' )
			? phrase.replace( '%s', marked )
			: marked + ' ' + phrase;
	}

	var controller = Marionette.Object.extend( {
		initialize: function() {

			// Respond to requests for field setting filtering.
			nfRadio.channel( 'textbox' ).reply( 'validate:updateSetting', this.validateSetting, this );
		},

		/**
		 * Sanitize field as needed to prevent xss
		 * 
		 * @since  3.8
		 * @param  Object 			e                event
		 * @param  backbone.model 	fieldModel       field model
		 * @param  string 			name             setting name
		 * @param  backbone.model 	settingTypeModel field type model
		 * @return escaped data after error triggered
		 */
		validateSetting: function( e, fieldModel, dataModel ) {
            //Check characters set in custom classes match sanitize_html_class
			if ( fieldModel.get('name').endsWith("_class" )) {
				const regexp = /^[a-zA-Z 0-9-_]+$/;
				if(e.target.value.search(regexp) === -1 &&  '' !== e.target.value){
					fieldModel.set('error', nfi18n.htmlDetectedError );
				} else if(e.target.value.search(regexp) === 0 || '' === e.target.value){
					fieldModel.unset('error');
				}
			}
			
            //Prevent xss from title and labels
			const isActionNameLabel = fieldModel.get('name') === "label" && fieldModel.get('label') === "Action Name";
            const checkedElements = ["title", "processing_label", "changeEmailErrorMsg", "changeDateErrorMsg", "confirmFieldErrorMsg", "fieldNumberNumMinError", "fieldNumberNumMaxError", "fieldNumberIncrementBy", "formErrorsCorrectErrors", "validateRequiredField", "honeypotHoneypotError", "fieldsMarkedRequired"];
            if( checkedElements.includes(fieldModel.get('name')) || isActionNameLabel ){
				const regexp = /[/"<>`]/;
				if(e.target.value.search(regexp) !== -1 &&  '' !== e.target.value){
					const foundIndex = e.target.value.search(regexp);
					const foundChar = e.target.value.charAt(foundIndex);
					fieldModel.set('error', nfGetForbiddenCharacterMessage( nfi18n.titleLabelsErrorMessage, foundChar ));
				} else if(e.target.value.search(regexp) === -1 || '' === e.target.value){
					fieldModel.unset('error');
				}
			}
		}

	});

	return controller;
} );
